/**
 * @generated SignedSource<<03b61a1b324b045c5cf6741585e2967f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SlackChannelTypeaheadQuery$variables = Record<PropertyKey, never>;
export type SlackChannelTypeaheadQuery$data = {
  readonly slackChannels: ReadonlyArray<{
    readonly id: string;
    readonly isArchived: boolean;
    readonly isMember: boolean;
    readonly isPrivate: boolean;
    readonly name: string;
  }>;
};
export type SlackChannelTypeaheadQuery = {
  response: SlackChannelTypeaheadQuery$data;
  variables: SlackChannelTypeaheadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "types",
        "value": "public_channel"
      }
    ],
    "concreteType": "GraphQLSlackChannel",
    "kind": "LinkedField",
    "name": "slackChannels",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPrivate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isMember",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isArchived",
        "storageKey": null
      }
    ],
    "storageKey": "slackChannels(types:\"public_channel\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SlackChannelTypeaheadQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SlackChannelTypeaheadQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "1931b255d2dc348dd48d9f2428fbb4be",
    "id": null,
    "metadata": {},
    "name": "SlackChannelTypeaheadQuery",
    "operationKind": "query",
    "text": "query SlackChannelTypeaheadQuery {\n  slackChannels(types: \"public_channel\") {\n    id\n    name\n    isPrivate\n    isMember\n    isArchived\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc7c88c6c2d441caf49be80e16aef240";

export default node;
